<template>
  <div
    class="fixed-bottom w-100 d-flex align-items-center justify-content-center font-size-base refresh-notification"
  >
    <Icon name="warning" width="38" class="refresh-notification_icon" />
    {{
      $t(
        '_web_signalr-reload_title',
        'It seems that we got the unexpected error with server connection, retry connect?'
      )
    }}
    <Btn class="refresh-notification_btn" @click.native="retry">
      {{ $t('_web_signalr-reload_retry', 'Retry') }}
    </Btn>
  </div>
</template>

<script>
import Icon from '@/components/atoms/Icon';
import Btn from '@/components/atoms/HeraFormBtn';
import { mapMutations } from 'vuex';

export default {
  components: {
    Icon,
    Btn,
  },

  methods: {
    ...mapMutations(['reconnectHub', 'setIsHubReloadRequired']),

    retry() {
      this.reconnectHub();
      this.setIsHubReloadRequired(false);
    },
  },
};
</script>

<style lang="scss">
.refresh-notification {
  height: 4rem;
  background-color: $ph-error;

  &_icon {
    @include auto-rtl(margin-right, 2rem);
    opacity: 0.2;
  }

  &_btn {
    @include auto-rtl(margin-left, 2rem);
  }
}
</style>
